var _path, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPersonalLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 4.53323V8.57401V15.4288V22.8134C0 23.4698 0.766071 24 1.71429 24C2.6625 24 3.42857 23.4698 3.42857 22.8134V15.4288V12.4936L10.575 19.9136C10.8911 20.2436 11.4268 20.4402 12 20.4402C12.5732 20.4402 13.1089 20.2436 13.425 19.9136L20.5714 12.4936V15.4288V22.8134C20.5714 23.4698 21.3375 24 22.2857 24C23.2339 24 24 23.4698 24 22.8134V15.4288V8.57401V1.18936C24 0.666511 23.5071 0.202989 22.7839 0.0509536C22.0607 -0.101082 21.2786 0.0954518 20.8607 0.529309L12 9.7293L3.13929 0.533017C2.72143 0.0954517 1.93929 -0.0973734 1.21607 0.0546619C0.492857 0.206697 0 0.666511 0 1.18936V1.65195L3.42857 5.20751V5.10891L10.575 12.529C10.8911 12.859 11.4268 13.0555 12 13.0555C12.5732 13.0555 13.1089 12.859 13.425 12.529L20.5714 5.10891V8.21431L12 17.1139L3.42857 8.2179V8.08879L0 4.53323Z"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "zima_to_drk_blue_gradient",
    x1: 0.5,
    y1: 12.5,
    x2: 24,
    y2: 12,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5BC2E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#020B16",
    stopOpacity: 0.8
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPersonalLogo);
export default __webpack_public_path__ + "static/media/personal_logo.7e069d6de8a5f6d8a0e71be181b4dc37.svg";
export { ForwardRef as ReactComponent };